"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlatButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
function FlatButton(_a) {
    var { willUnmount, onUnmountAnimationEnd } = _a, props = __rest(_a, ["willUnmount", "onUnmountAnimationEnd"]);
    const ref = react_1.default.useRef(null);
    const ANIMATION_DURATION = 200;
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { nodeRef: ref, in: !willUnmount, timeout: ANIMATION_DURATION, onExited: onUnmountAnimationEnd, unmountOnExit: true, "data-e2e": 'FlatButton_CSSTransition', children: (0, jsx_runtime_1.jsx)(Button, Object.assign({ ref: ref, animationDuration: ANIMATION_DURATION }, props, { "data-e2e": 'FlatButton_Button' })) }));
}
exports.FlatButton = FlatButton;
/**
 * Button with transparent background and border.
 */
const Button = styled_components_1.default.button `
  padding: 12px 16px;
  width: 100%;

  background: transparent;
  border-radius: 4px;
  border: none;

  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  text-transform: uppercase;
  text-align: center;

  color: ${({ theme }) => theme.designSystem.white};

  cursor: pointer;

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0;
    transition: opacity ${({ animationDuration }) => animationDuration}ms
      ease-in;
  }

  &.exit-done {
    opacity: 0;
  }
`;
